import { EQuotationEntryPoints } from "libraries/enums/e-quotation-entry-points";

export enum TabCode {
    option = 'option',
    included = 'included',
}

export interface ITab {
    allow: boolean;
    label: string;
    active?: boolean;
    permission?: string;
    disabled?: boolean;
    tabDetector?: string;
    routerLink?: string;
    queryParams?: any;
    code?: TabCode | EQuotationEntryPoints;
    tabs?: ITab[];
}
